import elementId from "./element-id";

export default function guid() {
    return elementId();
}
